import { buildWindowScript, chartAdvice } from '../../../platform/tradingview';
import config from '../config';

// This mode's settlement window, for the TradingView check: the target
// session (end_date) from its open to its close, with the previous session's
// close alongside, since the gap between the two is what was forecast.
export const chartWindow = batch => ({
  start: { date: batch.end_date, hour: 9, minute: 30 },
  end: batch.target_close,
  priorClose: true,
});

// What SymbolChart needs for each ticker on a prediction's page.
export function chartFor(batch, prices = []) {
  const span = chartWindow(batch);
  return {
    advice: chartAdvice(span),
    build: symbol => () => {
      const p = prices.find(x => x.symbol === symbol);
      return buildWindowScript({
        symbol, window: span,
        recorded: { start: p?.start_close, end: p?.end_close },
        title: `${config.title} · ${batch.horizon}`,
        url: globalThis.location?.href || '',
      });
    },
  };
}
